import React from "react";
import { Link } from "react-router-dom";
import BackArrow from '../../../assets/images/Frame_18177.png';

const StepOne = () => {
    return(
        <>
            <div className='flex w-full'>
                {/* section 1 */}
                <div className='flex-1 flex items-center mt-4'>
                    <Link
                        to="/"
                        className={`flex w-28 ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200`}
                        style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                    >
                        <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                        Back
                    </Link>
                    <span className=' ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>New Registration</span>
                </div>

                {/* section 2 */}
                {/* <div className='flex-1 flex items-center justify-center mt-4'>
                    <ol className="flex items-center justify-between w-full">
                        <li className="relative flex flex-col flex-grow">
                            <div className="flex items-center ml-10">
                                <div className="z-10 flex items-center justify-center w-6 h-6 bg-white border border-[#7F56D9] rounded-full">
                                    <span className="flex w-3 h-3 bg-[#7F56D9] rounded-full"></span>
                                </div>
                                <div className="flex-grow h-0.5 bg-gray-200 dark:bg-gray-700"></div>
                            </div>
                            <div className="mt-3">
                                <h3 className="font-medium text-gray-900 dark:text-white">Patient Details</h3>
                            </div>
                        </li>

                        <li className="relative flex flex-col flex-grow">
                            <div className="flex items-center">
                                <div className="flex-grow h-0.5 bg-gray-200 dark:bg-gray-700"></div>
                                <div className="z-10 flex items-center justify-center w-6 h-6 bg-white border border-[#FFFFFF] rounded-full">
                                    <span className="flex w-3 h-3 bg-[#FFFFFF] rounded-full"></span>
                                </div>
                                <div className="flex-grow h-0.5 bg-gray-200 dark:bg-gray-700" style={{ paddingRight: "40px" }}></div>
                            </div>
                            <div className="mt-3">
                                <h3 className="font-medium text-gray-900 dark:text-white">Book Consultation</h3>
                            </div>
                        </li>

                        <li className="relative flex flex-col flex-grow">
                            <div className="flex items-center">
                                <div className="h-0.5 bg-gray-200 dark:bg-gray-700" style={{ width: "40px" }}></div>
                                <div className="z-10 flex items-center justify-center w-6 h-6 bg-white border border-[#FFFFFF] rounded-full">
                                    <span className="flex w-3 h-3 bg-[#FFFFFF] rounded-full"></span>
                                </div>
                            </div>
                            <div className="mt-3">
                                <h3 className="font-medium text-gray-900 dark:text-white">Make Payment</h3>
                            </div>
                        </li>
                    </ol>
                </div> */}

                {/* section 3 */}
                <div className='flex-1'></div>
            </div>

            <hr className="mt-4 ml-14 mr-14 border-t-1 border-gray-300" />
        </>
    )
}

export default StepOne;